module.exports = __webpack_public_path__ + "static/8-insights-6d346a57de03c4594940bce758c8be5a.jpg";